import { datadogRum } from "@datadog/browser-rum";
import { IconExclamationCircle } from "@tabler/icons-react";
import React, { ReactNode } from "react";

import { OrgAnchor } from "~/components/OrgAnchor";
import { Text } from "~/ui";

type Props = {
  children?: ReactNode;
};

type State = {
  error: Error | null;
};

export class ShelfCycleErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    datadogRum.addError(error, {
      info,
    });
  }

  render() {
    if (this.state.error != null) {
      return <ErrorComponent />;
    }
    return this.props.children;
  }
}

export const ErrorComponent = () => {
  return (
    <Text pl="25%">
      <IconExclamationCircle size="55px" color="red" />
      <Text size="35px" fw={700}>
        Sorry, something went wrong.
      </Text>
      <Text pt="md">
        An error like this means we did something wrong, not you, and we apologize for that.
        <p></p>
        The team has been notified of the situation.
      </Text>
      <Text pt="md">
        <OrgAnchor href="/products">Click for home</OrgAnchor>
      </Text>
    </Text>
  );
};
